import { intRu } from './format.js';
/**
 * Вывод прогноза словами (спека §5.4, §6.7). Пороги — те же, что у auto-ads
 * (`VERDICT_P_HIGH`/`VERDICT_P_LOW`, `MIN_N_VERDICT`/`MIN_N_VERDICT_FIRM`):
 * только для подписей «Как читать цифры», сам вывод считает бэкенд.
 */
export const VERDICT_P_HIGH = 0.8;
export const VERDICT_P_LOW = 0.2;
export const MIN_N_VERDICT = 30;
export const MIN_N_VERDICT_FIRM = 184;
const LABEL = {
    yes: 'Скорее да',
    unclear: 'Неясно',
    no: 'Скорее нет',
    none: 'Мало покупок',
};
export function verdictLabel(v) {
    return LABEL[v ?? 'none'];
}
/** Этап (момент отчёта) посчитан для корзины, если прогноз есть у ≥ 90 % её покупок. */
export const VERDICT_READY_SHARE = 0.9;
/** Доля покупок с прогнозом момента отчёта (из ответа; нет — из счётчиков). */
export function groupCoverage(g) {
    if (typeof g.coverage === 'number' && Number.isFinite(g.coverage))
        return g.coverage;
    return g.purchases > 0 ? g.purchasesWithPrediction / g.purchases : null;
}
/**
 * Вывода нет, потому что прогноз этого момента есть ещё не у всех покупок
 * (покрытие < 90 %), а покупок для вывода хватает (≥ 30): «Ещё рано», а не
 * «Мало покупок». Меньше 30 покупок — вывода не будет и потом, это «Мало
 * покупок» даже при неполном покрытии. Возвращает подсказку или `null`.
 */
export function earlyHint(g) {
    if (g.answer.verdict !== null || g.purchases < MIN_N_VERDICT)
        return null;
    const c = groupCoverage(g);
    if (c === null || c >= VERDICT_READY_SHARE)
        return null;
    return `ещё рано: прогноз этого этапа есть у ${intRu(g.purchasesWithPrediction)} из ${intRu(g.purchases)} покупок`;
}
/** Подпись вывода группы с учётом «Ещё рано». */
export function groupVerdictLabel(g) {
    return earlyHint(g) ? 'Ещё рано' : verdictLabel(g.answer.verdict);
}
export function verdictTone(v) {
    return v ?? 'none';
}
/** «предварительно: 41 из 184 покупок»; вывод окончательный — `null`. */
export function preliminaryHint(g) {
    if (!g.answer.preliminary || g.answer.verdict === null)
        return null;
    return `предварительно: ${intRu(g.purchases)} из ${MIN_N_VERDICT_FIRM} покупок`;
}
/**
 * Причина «—» по-человечески: тексты auto-ads («мало данных», «покрытие
 * компонентов …», «маркер известен с момента t24») в UI не попадают.
 */
export function reasonText(reason) {
    const r = (reason ?? '').toLowerCase();
    if (r.includes('нет расхода'))
        return 'нет расхода';
    if (r.includes('t24'))
        return 'признак становится известен через сутки';
    if (r.includes('d14'))
        return 'признак становится известен на 14-й день';
    if (r.includes('покрыт') || r.includes('компонент'))
        return 'не для всех покупок посчитаны вычеты';
    if (r.includes('мало') || /n\s*<\s*\d+/.test(r))
        return 'мало покупок';
    return 'нет оценки';
}
//# sourceMappingURL=verdict.js.map